var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.979,
    height: 30.005,
    viewBox: "0 0 23.979 30.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-4.021 -0.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M28,7.5A2.5,2.5,0,0,0,25.5,5H20.9a5,5,0,0,0-9.8,0H6.5a2.5,2.5,0,0,0-.456,4.954l.8,16.888A4.358,4.358,0,0,0,11.209,31h9.582a4.358,4.358,0,0,0,4.36-4.158l.8-16.888A2.5,2.5,0,0,0,28,7.5ZM16,3a3,3,0,0,1,2.816,2H13.184A3,3,0,0,1,16,3Zm7.153,23.748A2.36,2.36,0,0,1,20.791,29H11.209a2.36,2.36,0,0,1-2.362-2.252L8.049,10h15.9ZM25.5,8H6.5a.5.5,0,0,1,0-1h19a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M13,25a1,1,0,0,0,1-1V14a1,1,0,0,0-2,0V24A1,1,0,0,0,13,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M19,25a1,1,0,0,0,1-1V14a1,1,0,0,0-2,0V24A1,1,0,0,0,19,25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.33fab92a.svg";
export { ForwardRef as ReactComponent };